// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_any from "../../google_wkt/gen/google_protobuf_any.js";
import * as Ocaml_protoc_plugin from "../../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Google = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_status.ml",
      79,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Status"
              ]]
          },
          "Rpc"
        ]]
    });

const Rpc = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_status.ml",
      128,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Status"
        ]]
    });

const Status = Caml_module.init_mod([
      "proto/third_party/google_rpc/gen/google_rpc_status.ml",
      165,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".google.rpc.Status";
}

function make(codeOpt, messageOpt, detailsOpt, param) {
  const code = codeOpt !== undefined ? codeOpt : 0;
  const message = messageOpt !== undefined ? messageOpt : "";
  const details = detailsOpt !== undefined ? detailsOpt : /* [] */0;
  return {
          code: code,
          message: message,
          details: details
        };
}

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "code",
            "code"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "message",
            "message"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_wkt__Google_protobuf_any.Google.Protobuf.Any;

const merge_details = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "details",
            "details"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          code: Curry._2(merge_code, t1.code, t2.code),
          message: Curry._2(merge_message, t1.message, t2.message),
          details: Curry._2(merge_details, t1.details, t2.details)
        };
}

function spec(param) {
  const $$let = Google_wkt__Google_protobuf_any.Google.Protobuf.Any;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "code",
                    "code"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "message",
                        "message"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "details",
                            "details"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              }),
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.code, param.message, param.details);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(code, message, details) {
  return {
          code: code,
          message: message,
          details: details
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.Status", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.code, param.message, param.details);
  };
}

function constructor$1(code, message, details) {
  return {
          code: code,
          message: message,
          details: details
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.Status", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Status, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Status"
        ]]
    }, Rpc, {
      Status: Status
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Status"
              ]]
          },
          "Rpc"
        ]]
    }, Google, {
      Rpc: Rpc
    });

export {
  Imported$pmodules ,
  Google ,
}
/* Google Not a pure module */
